// extracted by mini-css-extract-plugin
module.exports = {"Container":"CorporateEvents_Container__MO0dS","ThingsToDoContainer":"CorporateEvents_ThingsToDoContainer__2Sk2g"};